import GlitchEffect from "./components/GlitchEffect";
import MouseFollower from "./components/MouseFollower";
import MarkerScribbles from "./components/MarkerScribbles";
import NeonReflections from "./components/NeonReflections";
import WaitlistSection from "./components/WaitlistSection";
import BackgroundAudio from "./components/BackgroundAudio";
import "./styles/glitch.css";

export default function App() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-black relative overflow-hidden">
      {/* Background Audio */}
      <BackgroundAudio
        src="https://pub-154819c037bc4d48860fa3298393b9cb.r2.dev/audio/deep_subharmonic_pad_with_gent_20250611_221413_5-1.wav"
        volume={0.3}
      />
      
      {/* Neon reflections - bottom layer */}
      <NeonReflections />
      
      {/* Main glitch effect - properly centered */}
      <div className="relative z-30 flex items-center justify-center">
        <GlitchEffect />
      </div>
      
      {/* Marker scribbles overlay */}
      <MarkerScribbles />
      
      {/* Waitlist section */}
      <WaitlistSection />
      
      {/* Mouse follower - top layer */}
      <MouseFollower />
      
      {/* Additional atmospheric effects */}
      <div className="fixed inset-0 pointer-events-none z-5">
        {/* Ambient glow */}
        <div 
          className="absolute inset-0 opacity-20"
          style={{
            background: `
              radial-gradient(circle at 20% 20%, rgba(0, 255, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(255, 0, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 50% 50%, rgba(255, 255, 0, 0.05) 0%, transparent 70%)
            `
          }}
        />
        
        {/* Film grain */}
        <div 
          className="absolute inset-0 opacity-30 mix-blend-overlay animate-pulse"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.4'/%3E%3C/svg%3E")`,
            backgroundSize: '200px 200px'
          }}
        />
      </div>
    </div>
  );
}